<div class="chat {{ mode }}">
  @let messages = visibleMessages();
  @let unread = unreadIds();
  <div class="messages-area">
    <cdk-virtual-scroll-viewport
      andorMessageListScroll
      [defaultItemHeight]="80"
      [bufferPx]="800"
      class="messages">
      <div
        *cdkVirtualFor="let message of messages; trackBy: trackById"
        class="message-row"
        [id]="'msg-' + message.id"
        [class.unread]="unread.has(message.id)"
        [class.highlighted]="highlightedMessageId() === message.id">
        <andor-chat-msg
          [message]="message"
          [viewImage]="viewImage"
          [layout]="chatLayout()"
          (replyRequested)="setReplyTarget($event)"
          (reactionToggled)="toggleReaction($event.message, $event.emoji)"
          (reactRequested)="onReactRequested($event)"
          (quoteClicked)="jumpToQuotedMessage($event)"></andor-chat-msg>
      </div>
    </cdk-virtual-scroll-viewport>
    @if (!messages.length) {
      <div class="messages-placeholder">
        <fa-icon [icon]="faMessageSmile"></fa-icon>
        <h2>#{{ roomName() }}</h2>
        <span>{{ 'Send a message to start the conversation!' | translate }}</span>
      </div>
    }
  </div>

  @if (showOverlay()) {
    <div class="scroll-overlay">
      @if (!atBottom()) {
        <button type="button" class="overlay-btn latest-btn" (click)="scrollToLatest()">
          ↓ {{ 'Back to latest' | translate }}
        </button>
      } @else if (roomUnreadCount() > 0) {
        <button type="button" class="overlay-btn unread-btn" (click)="scrollToFirstUnread()">
          ↑ {{ 'Jump to first unread' | translate }} ({{ roomUnreadCount() }})
        </button>
      }
    </div>
  }

  @if (errorMessage(); as msg) {
    <div class="message-error" role="alert">
      <fa-duotone-icon [icon]="faTriangleExclamation" class="icon"></fa-duotone-icon>
      <span class="text">{{ msg }}</span>
      <button
        type="button"
        class="dismiss"
        (click)="errorMessage.set(undefined)"
        [attr.aria-label]="'Dismiss' | translate">
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
    </div>
  }

  <div class="write-message">
    @if (replyTarget(); as reply) {
      <div class="reply-strip" [class.private]="replyIsPrivate()">
        <span class="reply-label">
          {{ (replyIsPrivate() ? 'Replying privately to' : 'Replying to') | translate }}
        </span>
        <span class="reply-sender">{{ replyToName() }}</span>
        <span class="reply-snippet">{{ replySnippet() }}</span>
        <button
          type="button"
          class="reply-cancel"
          (click)="setReplyTarget(undefined)"
          [attr.aria-label]="'Cancel reply' | translate">
          <fa-icon [icon]="faXmark"></fa-icon>
        </button>
      </div>
    }
    @if (imagePreview(); as preview) {
      <div class="image-preview-container">
        <img
          class="image-preview"
          [src]="preview | blobUrl"
          decoding="async"
          alt="{{ 'Selected Image' | translate }}" />
        @if (isCompressing()) {
          <div class="image-overlay">
            <span class="spinner-wrap">
              <fa-duotone-icon [icon]="faSpinnerThird" class="overlay-icon"></fa-duotone-icon>
            </span>
          </div>
        } @else if (imageNeedsCompression()) {
          <div class="image-overlay">
            <fa-duotone-icon [icon]="faArrowsMinimize" class="overlay-icon"></fa-duotone-icon>
            <span>{{ 'Will be compressed on send' | translate }}</span>
          </div>
        }
        <fa-icon
          class="image-preview-close"
          (click)="removeAttachment()"
          [icon]="faXmark"></fa-icon>
      </div>
    }
    <div class="text">
      <andor-rte #inputField [paste]="paste"></andor-rte>
      <button class="attachment" (click)="addAttachment()" #attachmentButton>
        <fa-icon [icon]="faImage" class="icon"></fa-icon>
      </button>
      <button class="send" (click)="sendMsg()" #sendButton>
        <fa-icon [icon]="faPaperPlane" class="icon"></fa-icon>
      </button>
    </div>
  </div>

  <dialog
    #imagePopoverContainer
    class="fullscreen-image-container"
    (click)="closeViewImage($event)">
    <img class="fullscreen-image" src="{{ popoverImage() }}" />
    <fa-icon
      class="fullscreen-close"
      (click)="closeViewImage($event, true)"
      [icon]="faXmark"></fa-icon>
  </dialog>

  <andor-context-menu
    #sharedEmojiMenu
    style="position: absolute"
    mode="styled"
    yPosition="below"
    xPosition="before"
    [overlapTrigger]="false"
    (closed)="onSharedMenuClosed()">
    <andor-emoji-picker
      #sharedEmojiPicker
      (selectedEmoji)="onSharedEmojiSelected($event)"></andor-emoji-picker>
  </andor-context-menu>
</div>
